import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { OpendialogOfferDetailsComponent } from 'app/components/dialog/open-dialog-offer-details/opendialog-offer-details.component';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-preview-offer',
  templateUrl: './admin-preview-offer.component.html',
  styleUrls: ['./admin-preview-offer.component.scss']
})
export class AdminPreviewOfferComponent extends SubscriptionBaseComponent implements OnInit, OnChanges {

  @Input() offerOverViewUpdate: boolean;
  @Input() offerPreview: FullOffer;
  @Input() imageUpdate: string;
  @Output() updateOfferPreview = new EventEmitter<boolean>();


  tab = 'thumbnail';
  offer = new FullOffer();
  imgDefault: string;
  userConnected: any;
  actionForm: string;
  offerKey: number;
  image: any;
  isLoading = false;
  color: ThemePalette = 'primary';

  constructor(
    private dialog: MatDialog,
    private dataService: DataService,
    private imgOfferDefault: ImgOfferDefaultService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private offerService: OfferService,
    private domSanitizer: DomSanitizer,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.offerPreview) this.image = null;

    this.offer = changes.offerPreview ? changes.offerPreview.currentValue : this.offer;
    if (changes?.imageUpdate?.currentValue) {
      this.isLoading = true;
      this.image = changes.imageUpdate.currentValue;
      this.isLoading = false;
    }
    if (changes.offerPreview && this.offerPreview) {
      this.isLoading = true;
      if (this.offerPreview?.offerKey && !changes.imageUpdate?.currentValue) {
        this.isLoading = true;
        this.getImage(this.offerPreview?.offerKey);
      } else {
        this.isLoading = false;
      }
    }
  }

  private async initComponent() {
    this.imgDefault = this.imgOfferDefault.imgDefault;
    this.userConnected = this.authService.getDecodedToken();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  changeTab(tab: string) {
    this.tab = tab;
    if (tab === 'offerDetails') { this.openDialogOfferDetails(); }
  }

  openDialogOfferDetails(): void {
    const dialogRef = this.dialog.open(OpendialogOfferDetailsComponent, {
      data: {
        offerSub: this.offer
      }
    });

    dialogRef.afterClosed().subscribe({
      next: () => { this.tab = 'thumbnail'; }
    });
  }

  getPhotoExperience(photoExperience: string): boolean {
    return photoExperience && !this.actionForm || ['add', 'edit'].includes(this.actionForm) ? true : false;
  }

  private getImage(offerKey: number) {
    this.offerService.getImgOffer(offerKey).subscribe({
      next: image => {
        const { imgDefault } = this.imgOfferDefault;
        this.image = image.pictureBase64 ?
          this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${image.pictureBase64}`) :
          imgDefault;

        this.isLoading = false;
      }
    });
  }
}
